import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPromotionsByGenre } from "features/Top/topSlice";
import { LIMIT_TOP, SERVICE } from "constants/global";
import CardItem from "../CardItem";
import ErrorDB from "components/ErrorDB";

const TabPanel = ({ isGrid, isTabActive, index, isInLine }) => {
  const dispatch = useDispatch();

  const { promotion_all, genre_init, promotion_genre } = useSelector(
    (state) => state.top
  );

  // set genre display
  const [currentPage, setCurrentPage] = useState(1);
  const [genre, setGenre] = useState(
    index > -1 ? genre_init[index] : promotion_all
  );

  const handleLoadPage = (currentPage) => {
    setCurrentPage(currentPage);
    dispatch(
      getPromotionsByGenre({
        genre: index > -1 ? index : null,
        currentPage: currentPage,
        service: SERVICE,
        limit: LIMIT_TOP,
      })
    );
  };

  // cập nhật lại genre sau khi call API
  useEffect(() => {
    if (isTabActive && promotion_genre) {
      setGenre({
        current_page: promotion_genre.current_page,
        data: genre.data.concat(promotion_genre.data),
        last_page: promotion_genre.last_page,
        next_page_url: promotion_genre.next_page_url,
      });
    }
  }, [promotion_genre]);

  return (
    isTabActive && (
      <div className="tab-panel active">
        {isInLine && <ErrorDB/>}
        <div className={`tab-panel-${isGrid ? "grid" : "list"} mt-3`}>
          {genre?.data?.length > 0 &&
            genre?.data?.map((item) => (
              <CardItem key={"tab" + index + "-" + item.id} item={item} />
            ))}
        </div>

        <div className="mt-4">
          <div
            className={
              genre?.last_page > 1 && currentPage < genre?.last_page
                ? ""
                : "invisible"
            }
          >
            <div
              onClick={() => handleLoadPage(currentPage + 1)}
              className="btn-tabs cursor-pointer"
            >
              もっと見る
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default TabPanel;
